import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Form, Button } from 'react-bootstrap';
import ReCAPTCHA from 'react-google-recaptcha';

import { UPDATE_PASSWORD_PATH } from '../config/routes';
import config from '../config/config';
import { useWebsite, setFlashMessage } from '../contexts/WebsiteContext';

import NavigationBar from '../components/NavigationBar';
import DisplayMessage from '../components/DisplayMessage';
import Footer from '../components/Footer/Footer';
import Menus from '../components/Menus';
import MediaList from '../components/MediaList';

function UpdatePasswordRequest() {
    const { t } = useTranslation();
    const { setIsLoading } = useWebsite();

    const [email, setEmail] = useState('');
    const [captchaToken, setCaptchaToken] = useState('');
    const [isCaptchaError, setIsCaptchaError] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);

    const handlePostEmail = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
          // Verify captcha token before submitting
          if (!captchaToken) {
            setIsCaptchaError(true);
            setIsLoading(false);
            return;
          }
          setIsCaptchaError(false);
          const resetPasswordPath = `${window.location.origin}${UPDATE_PASSWORD_PATH}`;
    
          const response = await fetch(`${config.apiUrl}user/update-password-request`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email, resetPasswordPath })});

          if (response.ok) {
            setIsSuccess(true);
          } else {
            setFlashMessage("Une erreur s'est produite", 'error');
          }

        } catch (error) {
          setFlashMessage("Une erreur s'est produite", 'error');
        }
        setIsLoading(false);
      };

      const handleCaptchaChange = (token) => {
        setCaptchaToken(token);
      };

    if (isSuccess) {
      return (
        <div>
          <h1 className="text-center">Mise à jour du mot de passe</h1>
          <p>Votre demande de mise à jour de votre mot de passe a été prise en compte. Veuillez consulter votre boîte e-mail afin de poursuivre l'opération de mise à jour de votre mot de passe.</p>
        </div>
      );
    }

    return (
        <div>
            <NavigationBar />
            <h1 className="text-center">Mise à jour du mot de passe</h1>
            <div className="justify-content-center">
              <div className='kubuni-frame' style={{ maxWidth: '600px', margin: '20px auto', marginBottom: '160px', padding: '10px 30px'}}>
                <Form onSubmit={handlePostEmail}>
                    <Form.Group controlId="formBasicUsername">
                    <Form.Label>Votre e-mail</Form.Label>
                    <Form.Control
                        type="email"
                        placeholder={t('LOGIN_EMAIL_PLACEHOLDER')}
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    </Form.Group>

                    <div className="text-center">
                    <div style={{margin:'20px auto', width: '300px'}}>
                    { isCaptchaError && <DisplayMessage messageType="error" message={t('CAPTCHA_ERROR')} />}
                        <ReCAPTCHA
                        sitekey={config.recaptchaKey}
                        onChange={handleCaptchaChange}
                        />
                    </div>
                    <Button variant="primary" type="submit" style={{ marginBottom:"20px" }}>
                        Valider
                    </Button>
                    </div>
                </Form>
                </div>
            </div>
            <div className="short-line"></div>
            <MediaList mediaKey='UPDATE_PASSWORD_BOTTOM' maxItems={1} isShortLine={true} />
            <Menus />
            <Footer />
        </div>
    );
}

export default UpdatePasswordRequest;
